import React from 'react';
import NotificationSystem from 'rc-notification';
import CloseIcon from '@material-ui/icons/Close';
import { mainColor, UNIT } from '../../constants';

const showNotification = (theme, rtl, color, title, message, fullWidth, bold, isToast) => {
  let notification = null;
  // eslint-disable-next-line no-return-assign
  if (!notification) {
    NotificationSystem.newInstance({ style: { top: 65, zIndex: isToast && 10000 } }, n => {
      notification = n;

      const notificationInitialProps = {
        content: fullWidth ? (
          <FullWideNotification color={color} message={message} />
        ) : (
          <BasicNotification color={color} title={title} message={message} theme={theme} bold={bold} />
        ),
        closable: true,
        closeIcon: <CloseIcon style={{ color: color==='warning' ?mainColor.colorBlack:mainColor.colorWhite, marginRight: -UNIT / 2 }} />,
        duration: 3,
        style: { top: 0, left: 'calc(100vw - 100%)' },
        className: `right-up ${rtl}-support p-1 `,
      };

      notification.notice(notificationInitialProps);
    });
  }
};


const BasicNotification = ({ color, title, message, theme, bold }) => (
  <div className={`notification notification--${color} notification--${theme.className}`}>
    {title && <h5 className={`${color==='warning'?'text-dark':'notification__title'} bold-text`}>{title}</h5>}
    {bold? <p className={`${color==='warning'?'text-dark':'notification__message'} text-break`} dangerouslySetInnerHTML={{ __html: message }} />:
      <p className='notification__message text-break'>{message}</p>}
    
  </div>
);


const ImageNotification = ({ img, title, message, theme }) => (
  <div className={`notification notification--image notification--${theme.className}`}>
    <div className='notification__image'>
      <img src={img} alt='' />
    </div>
    <h5 className='notification__title bold-text'>{title}</h5>
    <p className='notification__message'>{message}</p>
  </div>
);

const FullWideNotification = ({ color, message }) => (
  <div className={`notification notification--full-wide notification--${color}`}>
    <p className='notification__message'>{message}</p>
  </div>
);

export { BasicNotification, ImageNotification, FullWideNotification, showNotification };